export default __webpack_public_path__ + "static/benzinga-66fea1ea7df600b0fa5262b210ae38a0.svg";